import { type AppState } from '../types';

export const getRelatedPosts = (state: AppState, postId: string) => state.relatedPosts[postId];
